module.exports = __webpack_public_path__ + "static/media/contractor-wages.609b9cd2.svg";